import './clickableSectionList.scss';
import {ClickableElement} from './clickableSectionList';
import classNames from 'clsx';
import {Icons} from '../../../../../icons/icons';
import {useTranslation} from 'react-i18next';
import React, {useState} from 'react';
import {Button} from 'react-bootstrap';
import {SvgIcon} from '../../../../../icons/svgIcon';
import {useDispatch} from 'react-redux';
import {resetTransformAction, setScrollTargetAction} from '../../../../duck/search-actions';
import {FilterWidget} from '../../../../../common/filterWidget/filterWidget';
import {HibuTextButton} from '../../../../../common/hibuTextButton/HibuTextButton';

export const TocRenderer = (clickableElements: ClickableElement[] | null) => {
    const {t} = useTranslation();
    const [expanded, setExpanded] = useState<boolean>(true);
    const [filter, setFilter] = useState('');
    const dispatch = useDispatch();

    if (clickableElements?.length === 0) {
        return null;
    }

    const onElementClick = (element: ClickableElement) => {
        dispatch(resetTransformAction(true));
        dispatch(setScrollTargetAction(element));
    };

    return (
        <div>
            <div className={'sections-list-header'}>
                <Button className={classNames('toggle-header')}
                        type={'button'}
                        aria-expanded={expanded}
                        aria-controls={t('fieldTitle.tagsPlural.tocHeader.label')}
                        onClick={() => setExpanded((isExpanded) => !isExpanded)}>
                    <SvgIcon icon={Icons.CHEVRON_DOWN} className={expanded ? 'expanded' : ''}/>
                    <div className={'toggle-label'}>{t('fieldTitle.tagsPlural.tocHeader.label')}</div>
                </Button>
                {expanded && (
                    <FilterWidget
                        filter={filter}
                        setFilter={setFilter}
                        title={t('fieldTitle.tagsPlural.tocHeader.label')}
                    />
                )}
            </div>
            {expanded && (
                <ul className={classNames('sections-list')}>
                    {clickableElements
                        ?.filter((el) => !filter || el.label.toLowerCase().includes(filter.toLowerCase()))
                        .map((element) => (
                            <li key={'id_' + element.label}>
                                <HibuTextButton disabled={false}
                                                label={element.label}
                                                onClick={() => onElementClick(element)}
                                                className={classNames('sections-element', 'toc-element')}>
                                </HibuTextButton>
                            </li>
                        ))}
                </ul>
            )}
        </div>
    );
};
